import React from 'react';
import ReactMarkdown from 'react-markdown';
import {Link} from '@reach/router';

const renderers = {
  link(props) {
    const {href, ...rest} = props;
    if (/^http/.test(href)) return <a {...props} />;
    return <Link {...rest} to={href} />;
  },
};

export default function Markdown(props) {
  return <ReactMarkdown {...props} renderers={renderers} />;
}
